export enum Role {
  SUPER_ADMIN = 'SUPER_ADMIN',
  STORE_ADMIN = 'STORE_ADMIN',
  MANAGER = 'MANAGER',
  APP_USER = 'APP_USER',
}
